import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { message, Input, Modal } from "antd";

import { PrimaryButton, WhiteButton } from "../../components/button";
import Spacer from "../../components/spacer/spacer";

import images from "../../assets";

export default function ReceiverMessageCard(props) {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const messageParts = props?.textmessage?.split("\n");

  return (
    <div {...props} className="premium-message-body-sender">
      <div className="premium-message-body-sender-with">
        <div
          className="premium-message-body-main-sender"
          onClick={() => {
            if (props?.maskApplied) {
              setOpen(true);
            }
          }}
        >
          <div
            className={`premium-message-body-text-mess ${
              props?.maskApplied && "blur-[5px] cursor-pointer"
            }`}
          >
            {messageParts.map((part, index) => (
              <p key={index}>{part}</p>
            ))}
          </div>
          <div className="premium-message-body-text-time">
            <p>{props.delivertime}</p>
          </div>
        </div>
      </div>
      <Modal
        centered={true}
        open={open}
        onCancel={() => setOpen(false)}
        footer={false}
        closable={false}
      >
        <div className="gap-4 set-profile-photo-content">
          <div className="set-profile-photo-icon">
            <img style={{ maxWidth: "40px" }} src={images?.deleteIcon} alt="" />
          </div>
          <div className="set-profile-photo-heading">
            <p className="!text-black">
              Message is hidden due to free plan.
              <br />
              <br />
              <strong>Upgrade</strong> to get full access. After upgrading, you
              can enjoy unlimited chat.
            </p>
          </div>
        </div>
        <Spacer height="16px" />
        <div className="flex w-full justify-end">
          <div className="flex gap-4 set-profile-photo-btn">
            <WhiteButton
              style={{
                width: "120px",
                border: "2px solid #EAE6ED",
              }}
              text={"Skip"}
              onClick={() => setOpen(false)}
            />
            <PrimaryButton
              style={{
                width: "157px",
              }}
              text={"Upgrade"}
              onClick={() => navigate("/membership-plan")}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}
